import { createSwitchNavigator } from "@react-navigation/core";
import { createBrowserApp } from "@react-navigation/web";
import { routeConfig } from "../../config/navigator-configs/auth-navigator-config";

const AuthNavigator = createSwitchNavigator(...routeConfig);

export const Auth = createBrowserApp(AuthNavigator);
